import "./App.css";
import { lazy, Suspense, useEffect, useMemo, useRef, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useAuth } from "./components/context/Auth";
import { debounce } from "./Utils/TextUtils";
import { useInactivity } from "./components/context/Inactivity";
import CryptoJS from "crypto-js";

import {
  Accounts,
  AddCollection,
  AddItem,
  AddManager,
  AddPartner,
  AddProduct,
  AddStyleAndType,
  AdjustmentInvoice,
  AllOrders,
  Apps,
  Campaign,
  CampaignReport,
  CollectionInfo,
  CommonDashboard,
  Complaints,
  CreateApp,
  CreateCampaign,
  CreateGroup,
  CreatePackers,
  CreateTemplate,
  DealerList,
  Dealers,
  Delivery,
  DispatchDasboard,
  DispatchDasboardMob,
  DispatchOrder,
  DispatchOrders,
  EditDelete,
  EstimateInvoice,
  Groups,
  Home,
  Inventory,
  InventoryCollections,
  Inventryreportdetails,
  Invoices,
  Items,
  Kyc,
  MainMobileChats,
  MainWhatsappChat,
  Managers,
  Marketing,
  MarketingLead,
  NavLayout,
  NewManager,
  Newviewdispatchdetails,
  NoMatch,
  Order,
  OrderDealers,
  OutSideInventory,
  OutSideInventoryMob,
  OutSideIvtColl,
  OutSideIvtCollInfo,
  OutSideIvtCollInfomob,
  OutSideIvtCollMob,
  Packer,
  Packers,
  PackingOrder,
  PackingOrders,
  PackingVoucher,
  ProductFAQ,
  Products,
  PurchaseInovice,
  Recipts,
  ReciptsMob,
  Refunds,
  SaleInvoice,
  SaleOrderInovice,
  SingleCampaing,
  SingleTemp,
  TaxRate,
  Templates,
  TestLink,
  Transactions,
  TransferDealer,
  TransferOrders,
  TransferOrdersMob,
  TransferStock,
  UploadInvoice,
  ViewApp,
  ViewDispatchDetailsMob,
  ViewProduct,
  Warehouse,
} from "./exports";
import { useNotification } from "./components/context/NotificationContext";
import PdfViewer from "./pages/superadmin/PdfViewer";
import { SocketConnected, socket } from "./Socket/socket";
import fetchData from "./APIsControll/apiControll";
import WhatsappMobSaleOrder from "./mobile/pages/WhatsappMobSaleOrder";
import Inventryproducts from "./pages/Inventryreport/Inventryproduct";
import Inventrycollectionitem from "./pages/Inventryreport/Inventrycollectionlist";
import Inventrycollectionitemmodal from "./pages/Inventryreport/Inventrycollection";
import BulkReception from "./components/updatedComponents/Receipts/BulkReception";
import Printers from "./components/updatedComponents/Printer/Printers";
import useBackButtonBlocker from "./hooks/BackButtonBlocker";
import { upsertOrder } from "./store/slices/order/OrderSlice";
import { useDispatch, useSelector } from "react-redux";
import Energy from "./components/updatedComponents/Energy/Energy";
import Settings from "./pages/Settings/Settings";
import { applyBranding, saveBranding } from "./Utils/brandingManager";
import { decryptData } from "./Encryption/Encryption";
import { useBranding } from "./components/context/BrandingContext";
import Delivery1 from "./pages/delivery/Delivery1";
import AddDeliveryMethod from "./pages/delivery/AddDeliveryMethod";
import AddDeliveryPartner from "./pages/delivery/AddDeliveryPartner";
import Production from "./pages/production/Production";
import ProductionDetails from "./pages/production/ProductionDetails";
import ManageProductionLine from "./pages/production/ManageProductionLine";

const AppSearchModal = lazy(() => import("./AppFeatures/AppSearchModal"));
const ModalWrapper = lazy(
  () => import("./components/updatedComponents/layoutWrapper/ModalWrapper"),
);
const TimerLogout = lazy(
  () => import("./components/updatedComponents/Login/TimerLogout"),
);

function App() {
  // const { showModal, setShowModal, } = useInactivity();
  // const { mode, loggedIn, setLoggedIn, designation, setDesignation,
  //   setManagerId, setManagerName, setDesignations, designations, setOrderData,
  //   managerId, setTotalUnreadChat, setWarehouse, saleWhatsapp, openSearchModal,
  const { showModal, setShowModal } = useInactivity();
  const {
    mode,
    loggedIn,
    setLoggedIn,
    designation,
    setDesignation,
    setManagerId,
    setManagerName,
    setDesignations,
    designations,
    managerId,
    setTotalUnreadChat,
    setWarehouse,
    saleWhatsapp,
    openSearchModal,
    setOpenSearchModal,
    setSettingsData,
  } = useAuth();
  const { setBranding } = useBranding();

  useBackButtonBlocker();
  const { addNotification, sendBrowserNotification } = useNotification();
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);
  const dispatch = useDispatch();
  const { filter } = useSelector((r) => r.order);

  useEffect(() => {
    const mid = sessionStorage.getItem("managerId");
    const encryptedName = sessionStorage.getItem("name")
      ? sessionStorage.getItem("name")
      : "";
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedName, "secret key");
    const mname = decryptedBytes.toString(CryptoJS.enc.Utf8);
    if (designation) {
      setLoggedIn(true);
    }
    if (mid) {
      setManagerId(mid);
    }
    if (mname) {
      setManagerName(mname);
    }
  }, [designation, setLoggedIn, setManagerId, setManagerName]);

  const getDesignation = sessionStorage.getItem("designation")
    ? sessionStorage.getItem("designation")
    : "";

  const decryptedDesignationBytes = CryptoJS.AES.decrypt(
    getDesignation,
    "secret key",
  );

  const designationsIs = decryptedDesignationBytes.toString(CryptoJS.enc.Utf8);

  const getDesignations = sessionStorage.getItem("designations")
    ? sessionStorage.getItem("designations")
    : "";

  const decryptedDesignationsBytes = CryptoJS.AES.decrypt(
    getDesignations,
    "secret key",
  );

  const designationss = decryptedDesignationsBytes.toString(CryptoJS.enc.Utf8);

  useEffect(() => {
    if (designationsIs) {
      setDesignation(designationsIs.split(",")[0]);
    }
  }, [setDesignation, designationsIs]);

  useEffect(() => {
    if (designationss) {
      setDesignations(JSON.parse(designationss));
    }
  }, [setDesignations, designationss]);

  useEffect(() => {
    const handleResize = debounce(() => {
      setWidth(window.innerWidth);
    }, 500);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const getManagerId = async () => {
      const id = await sessionStorage.getItem("managerId");
      setManagerId(id);
    };
    getManagerId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        loggedIn &&
        Array.isArray(designations) &&
        (designations.includes("superadmin") ||
          designations.includes("inventorymanager") ||
          designations.includes("ordermanager"))
      ) {
        const isInputFocused = ["INPUT", "TEXTAREA", "SELECT"].includes(
          document.activeElement.tagName,
        );

        if (event.altKey && event.key?.toLowerCase() === "v") {
          event.preventDefault();
          setOpenSearchModal(false);
          navigate("/orders/order/saleorder");
          return;
        }

        if (!isInputFocused && event.key?.toLowerCase() === "v") {
          event.preventDefault();
          setOpenSearchModal(false);
          navigate("/orders/order/saleorder");
          return;
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn, designations]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (designations.includes("superadmin") && loggedIn) {
        if (event.ctrlKey && event.key?.toLowerCase() === "k") {
          event.preventDefault();
          setOpenSearchModal(true);
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [designations, loggedIn, setOpenSearchModal]);

  useEffect(() => {
    if (!managerId || !designation) {
      SocketConnected({
        socketUserId: `${localStorage.getItem("UnDeviceId")}`,
        role: "manager",
        warehouseNames: [],
      });
    }
  }, [designation, managerId]);

  useEffect(() => {
    socket.on("getdeviceIdStatus", (getdeviceIdStatus) => {
      if (
        getdeviceIdStatus?.updatedDevice?.deviceId ===
          localStorage.getItem("UnDeviceId") ||
        getdeviceIdStatus?.permissions?.deviceId ===
          localStorage.getItem("UnDeviceId")
      ) {
        if (
          getdeviceIdStatus?.updatedDevice?.deviceActive === "disabled" ||
          getdeviceIdStatus?.permissions?.deviceActive === "disabled"
        ) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      }
    });
  }, []);

  useEffect(() => {
    const storedWarehouse = JSON.parse(localStorage.getItem("warehouse"));
    setWarehouse(storedWarehouse);

    if (!managerId || !designation) return;

    const isSuperAdmin = designation.includes("superadmin");

    const socketData = {
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: storedWarehouse,
    };

    SocketConnected(socketData);

    const handleAllOrder = (updatedOrders) => {
      const newOrder = updatedOrders?.allOrder?.data?.[0];
      if (!newOrder) return;

      const myManagerId = String(managerId);
      const assignedManagerId = String(newOrder.assignedManagerId);
      const orderManagerId = String(newOrder.managerId);

      const shouldProcessOrder =
        isSuperAdmin ||
        assignedManagerId === myManagerId ||
        orderManagerId === myManagerId;

      if (!shouldProcessOrder) {
        return;
      }

      if (filter.selectedFilter === "All") {
        dispatch(upsertOrder(newOrder));
      }

      if (newOrder.status === "Payment Pending") {
        addNotification("New order received!", "info");
        sendBrowserNotification(
          `New Order #${newOrder.orderId}!`,
          `Order #${newOrder.orderId} was placed.`,
          "/assets/updatedAssets/logo.png",
          "/orders",
        );
      } else if (newOrder.status === "Packing In Progress") {
        addNotification("Payment received!", "info");
        sendBrowserNotification(
          `Updated order #${newOrder.orderId}!`,
          `Payment received for order #${newOrder.orderId}.`,
          "/assets/updatedAssets/logo.png",
          "/orders",
        );
      }
    };

    socket.on("allorder", handleAllOrder);

    return () => {
      socket.off("allorder", handleAllOrder);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    designation,
    designations,
    managerId,
    filter.selectedFilter,
    // addNotification,
    // dispatch,
    // sendBrowserNotification,
    // setWarehouse,
  ]);

  // useEffect(() => {
  //   const storedWarehouse = JSON.parse(localStorage.getItem("warehouse"));
  //   setWarehouse(storedWarehouse);

  //   const isSuperAdmin = designation.includes("superadmin");

  //   // const assignedManagerIdMatched = managerId === updatedOrders.assignedManagerId

  //   // const managerIdMatched = managerId === updatedOrders.managerId;

  //   if (!managerId || !designation) return;

  //   const socketData = {
  //     socketUserId: `${managerId}`,
  //     role: designation,
  //     warehouseNames: storedWarehouse,
  //   };

  //   // console.log("socket data ", socketData);

  //   SocketConnected(socketData);

  //   const handleAllOrder = (updatedOrders) => {
  //     // console.log("updateOrder", updatedOrders);

  //     const newOrder = updatedOrders?.allOrder?.data?.[0];
  //     if (!newOrder) return;

  //     dispatch(upsertOrder(newOrder));

  //     if (newOrder.status === "Payment Pending") {
  //       addNotification("New order received!", "info");
  //       sendBrowserNotification(
  //         `New Order #${newOrder.orderId}!`,
  //         `Order #${newOrder.orderId} was placed.`,
  //         "/assets/updatedAssets/logo.png",
  //         "/orders"
  //       );
  //     } else if (newOrder.status === "Packing In Progress") {
  //       addNotification("Payment received!", "info");
  //       sendBrowserNotification(
  //         `Updated order #${newOrder.orderId}!`,
  //         `Payment received for order #${newOrder.orderId}.`,
  //         "/assets/updatedAssets/logo.png",
  //         "/orders"
  //       );
  //     }
  //   };

  //   socket.on("allorder", handleAllOrder);

  //   return () => {
  //     socket.off("allorder", handleAllOrder);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [designation, managerId]);
  // }

  const previousUnreadCount = useRef(0);

  const audio = new Audio("./assets/whatsapp_notification.mp3");
  const allowedDesignations = [
    "ordermanager",
    "inventorymanager",
    "dispatchmanager",
    "paymentmanager",
    "packingmanager",
  ];

  const handleUnReadChats = async () => {
    const isAllowed = designations.some((role) =>
      allowedDesignations.includes(role),
    );
    if (isAllowed) {
      try {
        const res = await fetchData("wallikonChat/unreadChats", {
          managerId: await sessionStorage.getItem("managerId"),
        });
        if (res.status === "success") {
          const newUnreadCount = res.totalUnreadChat;
          if (
            newUnreadCount > previousUnreadCount.current &&
            designation === ""
          ) {
            audio
              .play()
              .catch((error) => console.error("Error playing sound:", error));
          }
          // Update the unread count state and ref
          setTotalUnreadChat(newUnreadCount);
          previousUnreadCount.current = newUnreadCount;
        } else {
          setTotalUnreadChat(0);
          previousUnreadCount.current = 0;
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const getManagerId = async () => {
      const id = await sessionStorage.getItem("managerId");
      setManagerId(id);
    };
    getManagerId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (managerId) {
      handleUnReadChats();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId]);

  useEffect(() => {
    // const socket = io(process.env.REACT_APP_URL);
    socket.on("updateAdminChats", (allAdminChats) => {
      if (allAdminChats) {
        handleUnReadChats();
      }
    });

    socket.on("updateDealerChats", (allDealerChats) => {
      if (allDealerChats) {
        // console.log("updateDealerChats", allDealerChats?.allDealerChats);

        handleUnReadChats();
        sendBrowserNotification(
          `New Message #${
            allDealerChats?.allDealerChats?.whatsapp ||
            allDealerChats.allDealerChats[0]?.whatsapp
          } !`,
          // `Message #${allDealerChats?.allDealerChats?.message[0]?.dealerChat || allDealerChats?.allDealerChats[0]?.message[0]?.dealerChat}`,
          "/assets/updatedAssets/logo.png",
          "/whatsappchats",
        );
      }
    });

    // Clean up on component unmount
    return () => {
      socket.off("updateAdminChats");
      socket.off("updateDealerChats");
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const SplitScreenLayout = () => {
    return (
      <div
        style={{
          display: "flex",
          height: "calc(100vh - 60px)",
          justifyContent: "center",
          transition: "background-color 0.5s ease-in-out",
        }}
      >
        <div
          style={{
            width: saleWhatsapp ? "75%" : "100%",
            transition: "width 0.5s ease-in-out",
          }}
        >
          <Order />
        </div>
        <div
          style={{
            width: saleWhatsapp ? "25%" : "0%",
            transition:
              "width 0.5s ease-in-out, background-color 0.5s ease-in-out",
            overflow: "hidden",
            justifyContent: "center",
          }}
        >
          <WhatsappMobSaleOrder />
        </div>
      </div>
    );
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const MemoizedSplitScreenLayout = useMemo(
    () => <SplitScreenLayout />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [saleWhatsapp],
  );

  useEffect(() => {
    const DEFAULT_TITLE = "Admin";

    const DEFAULT_FAVICON = "/favicon.png";

    const resetBranding = () => {
      localStorage.removeItem("branding");

      // Reset browser branding
      applyBranding({
        title: DEFAULT_TITLE,

        favicon: DEFAULT_FAVICON,
      });

      // Reset context branding
      setBranding({
        title: DEFAULT_TITLE,

        favicon: DEFAULT_FAVICON,
      });

      // Reset settings state
      setSettingsData({
        companyLogo: "",
        companyName: "",
        paymentGatewayAccess: false,
        projectName: "",
        websiteLink: "",
      });
    };

    const getSettingsData = async () => {
      try {
        const response = await fetchData(`managers/getSettingsData`);

        const res = decryptData(response.res);

        // console.log(res);

        if (res?.status !== "success") {
          resetBranding();

          return;
        }

        //  Safe title
        const projectTitle =
          res?.projectName && res.projectName.trim() !== ""
            ? res.projectName
            : DEFAULT_TITLE;

        //  Safe logo
        const logoUrl =
          res?.companyLogo && res.companyLogo !== "" && res.companyLogo !== null
            ? process.env.REACT_APP_S3URL + res.companyLogo
            : DEFAULT_FAVICON;

        const brandingData = {
          title: projectTitle,

          favicon: logoUrl,
        };

        //  Browser branding
        applyBranding(brandingData);

        //  Save cache
        saveBranding(brandingData);

        //  Update Context
        setBranding(brandingData);

        //  Save settings state
        setSettingsData({
          companyLogo: res.companyLogo || "",

          companyName: res.companyName || "",

          paymentGatewayAccess: res.paymentGatewayAccess || false,

          projectName: projectTitle,

          websiteLink: res.paymentGatewayAccess ? res.websiteLink : "",
        });
      } catch (error) {
        console.log(error);

        //  Network/API Error
        resetBranding();
      }
    };

    getSettingsData();
  }, []);

  return (
    <div
      className="main_container"
      style={{ backgroundColor: mode ? "#232529" : "#D9DCE5" }}
    >
      {showModal && (
        <ModalWrapper
          isOpen={showModal}
          onClose={() => setShowModal(true)}
          backgroundColor={true}
        >
          <div
            style={{
              background: mode ? "#2C2E33" : "#fff",
              color: mode ? "#fff" : "#000",
              border: mode ? "none" : "1px solid #ccc",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <TimerLogout setShowModal={setShowModal} />
          </div>
        </ModalWrapper>
      )}

      <Suspense fallback={<div>Loading...</div>}>
        {openSearchModal && (
          <ModalWrapper
            isOpen={openSearchModal}
            onClose={() => setOpenSearchModal(false)}
          >
            <AppSearchModal
              mode={mode}
              close={() => setOpenSearchModal(false)}
            />
          </ModalWrapper>
        )}
      </Suspense>

      <Suspense fallback={<div>Loading...</div>}>
        {!loggedIn ? (
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        ) : (
          <div className="content">
            <Routes>
              <Route path="/" element={<NavLayout />}>
                <Route index element={<AddManager />} />

                {designations.includes("superadmin") && (
                  <>
                    <Route path="/dashboard" element={<CommonDashboard />} />
                    <Route path="/profile" element={<AddManager />} />
                    {/* Dealer Routes */}

                    <Route path="/dealers" element={<Dealers />} />
                    <Route path="/dealers/:id" element={<Kyc />} />
                    <Route
                      path="/dealers/transferdealer"
                      element={<TransferDealer />}
                    />
                    {/* Order Routes */}

                    <Route path="/orders" element={<AllOrders />} />
                    <Route path="/orders/order/saleorder" element={<Order />} />
                    <Route path="/orders/order/:route" element={<Order />} />
                    {/* Receipts */}

                    <Route
                      path="/recipts"
                      element={width < 1084 ? <ReciptsMob /> : <Recipts />}
                    />
                    <Route
                      path="/recipts/bulkreception"
                      element={<BulkReception />}
                    />
                    {/* Dispatch */}

                    <Route
                      path="/dispatch"
                      element={
                        width < 1084 ? (
                          <DispatchDasboardMob />
                        ) : (
                          <DispatchDasboard />
                        )
                      }
                    />
                    <Route
                      path="/dispatch/dispatchorders"
                      element={<DispatchOrders />}
                    />
                    <Route
                      path="/dispatch/dispatchorders/:orderId"
                      element={<PackingVoucher />}
                    />
                    {/* Inventory */}

                    <Route path="/inventory" element={<Inventory />} />
                    <Route
                      path="/inventory/:product"
                      element={<InventoryCollections />}
                    />
                    <Route path="/inventory/taxrate" element={<TaxRate />} />
                    <Route
                      path="/inventory/:product/:collection"
                      element={<CollectionInfo />}
                    />
                    {/* inventory report */}

                    {/* Campaigns */}
                    <Route path="/campaign/templates" element={<Templates />} />
                    <Route path="/campaign" element={<Campaign />} />
                    <Route
                      path="/campaign-report/:tempname/:campaignName"
                      element={<CampaignReport />}
                    />
                    <Route
                      path="/campaign/newcampaign"
                      element={<CreateCampaign />}
                    />
                    <Route
                      path="/singlecampaign/:campaing"
                      element={<SingleCampaing />}
                    />
                    <Route path="/campaign/groups" element={<Groups />} />
                    <Route path="/newgroup" element={<CreateGroup />} />
                    <Route
                      path="/newgroup/:tempname"
                      element={<DealerList />}
                    />
                    <Route path="/singeltemp" element={<SingleTemp />} />
                    <Route
                      path="/templates/template"
                      element={<CreateTemplate />}
                    />
                    {/* Managers */}

                    <Route path="/managers" element={<Managers />} />
                    <Route path="/managers/manager" element={<AddManager />} />
                    <Route
                      path="/managers/newmanager"
                      element={<NewManager />}
                    />
                    <Route
                      path="/managers/newmanager/:manager_Id"
                      element={<NewManager />}
                    />
                    {/* Products */}

                    <Route path="/products" element={<Products />} />
                    <Route
                      path="/products/product/:product"
                      element={<ViewProduct />}
                    />
                    <Route
                      path="/products/items/:product/:collection"
                      element={<Items />}
                    />
                    <Route
                      path="/products/item/:product/:collection"
                      element={<AddItem />}
                    />
                    <Route
                      path="/products/addstyle/:product"
                      element={<ViewProduct />}
                    />
                    <Route
                      path="/products/item/newitem/:product/:collection"
                      element={<AddItem />}
                    />
                    <Route
                      path="/products/:Product/faq"
                      element={<ProductFAQ />}
                    />
                    <Route
                      path="/products/addstyle/:productname/:productId"
                      element={<AddStyleAndType />}
                    />
                    <Route
                      path="/products/addtype/:productname/:productId"
                      element={<AddStyleAndType />}
                    />
                    <Route
                      path="/products/addproduct"
                      element={<AddProduct />}
                    />
                    <Route
                      path="/products/product/addcollection/:productName"
                      element={<AddCollection />}
                    />

                    {/* Marketing */}
                    <Route path="/marketing" element={<Marketing />} />
                    <Route
                      path="/marketing-lead/:id"
                      element={<MarketingLead />}
                    />

                    {/* Invoices */}
                    <Route
                      path="/orders/saleinvoice"
                      element={<SaleOrderInovice />}
                    />
                    <Route
                      path="/orders/estimateinvoice"
                      element={<EstimateInvoice />}
                    />
                    <Route
                      path="/orders/purchaseinvoice/:voucherNo"
                      element={<PurchaseInovice />}
                    />
                    <Route
                      path="/orders/adjustmentinvoice/:voucherNo"
                      element={<AdjustmentInvoice />}
                    />

                    {/* Transfer Orders */}
                    <Route
                      path="/orders/transfer"
                      element={<TransferStock />}
                    />
                    <Route
                      path="/transferorders"
                      element={
                        width < 1084 ? (
                          <TransferOrdersMob />
                        ) : (
                          <TransferOrders />
                        )
                      }
                    />

                    {/* Dispatch & Packing */}
                    <Route
                      path="/dispatch/details/:orderId/:warehouseId"
                      element={
                        width < 1084 ? (
                          <ViewDispatchDetailsMob />
                        ) : (
                          <Newviewdispatchdetails />
                        )
                      }
                    />
                    <Route path="/packingorder" element={<PackingOrders />} />
                    <Route
                      path="/packingorder/:orderId"
                      element={<PackingOrder />}
                    />
                    <Route path="/packers" element={<Packers />} />
                    <Route path="/packer/:pmId" element={<Packer />} />
                    <Route path="/createpacker" element={<CreatePackers />} />

                    {/* Other Routes */}
                    <Route path="/complaints" element={<Complaints />} />
                    <Route path="/accounts" element={<Accounts />} />
                    <Route path="/delivery" element={<Delivery />} />
                    <Route
                      path="/delivery/addpartner"
                      element={<AddPartner />}
                    />
                    {/* -------------Updated Delivery------------ */}
                    <Route path="/delivery1" element={<Delivery1 />} />
                    <Route
                      path="/delivery/adddeliverymethod"
                      element={<AddDeliveryMethod />}
                    />
                    <Route
                      path="/delivery/adddeliverypartner"
                      element={<AddDeliveryPartner />}
                    />
                    {/* ---------------------------------------------- */}
                    <Route path="/warehouses" element={<Warehouse />} />
                    <Route path="/deleteoredit" element={<EditDelete />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/invoices/invoice" element={<SaleInvoice />} />
                    <Route
                      path="/invoices/uploadedinvoice"
                      element={<UploadInvoice />}
                    />
                    <Route path="/invoices/viewpdf" element={<PdfViewer />} />

                    {/* Out Side Inventory */}
                    <Route
                      path="/outsideinventory"
                      element={
                        width < 1084 ? (
                          <OutSideInventoryMob />
                        ) : (
                          <OutSideInventory />
                        )
                      }
                    />
                    <Route
                      path="/outsideinventory/:product"
                      element={
                        width < 1084 ? (
                          <OutSideIvtCollMob />
                        ) : (
                          <OutSideIvtColl />
                        )
                      }
                    />
                    <Route
                      path="/outsideinventory/:product/:collection"
                      element={
                        width < 1084 ? (
                          <OutSideIvtCollInfomob />
                        ) : (
                          <OutSideIvtCollInfo />
                        )
                      }
                    />

                    {/* Inventryreport report */}
                    <Route
                      path="/Inventryreport"
                      element={<Inventryreportdetails />}
                    />
                    <Route
                      path="/Inventryreport/products"
                      element={<Inventryproducts />}
                    />
                    <Route
                      path="/Inventryreport/item"
                      element={<Inventrycollectionitem />}
                    />
                    <Route
                      path="/Inventryreport/item"
                      element={<InventoryCollections />}
                    />
                    <Route
                      path="/Inventryreport/item/modal"
                      element={<Inventrycollectionitemmodal />}
                    />

                    {/* WhatsApp Chats */}
                    <Route
                      path="/whatsappchats"
                      element={
                        width < 1084 ? (
                          <MainMobileChats />
                        ) : (
                          <MainWhatsappChat />
                        )
                      }
                    />

                    {/* Apps */}
                    <Route path="/apps" element={<Apps />} />
                    <Route path="/apps/view" element={<ViewApp />} />
                    <Route path="/apps/edit" element={<CreateApp />} />
                    <Route path="/apps/create" element={<CreateApp />} />

                    {/* Printers */}
                    <Route path="/printers" element={<Printers />} />

                    {/* transactions */}
                    <Route path="/transactions" element={<Transactions />} />

                    {/* refunds */}
                    <Route path="/refunds" element={<Refunds />} />

                    {/* Test */}
                    <Route
                      path="/inventory-report"
                      element={<Inventryreportdetails />}
                    />
                    <Route path="/TestLink" element={<TestLink />} />
                    <Route
                      path="/Inventryreportdetails"
                      element={<Inventryreportdetails />}
                    />
                    <Route
                      path="/Inventryreport"
                      element={<Inventryreportdetails />}
                    />

                    {/*
                     <Route path="/Inventryreport/products" element={<Inventryproducts />} />
                     <Route path="/Inventryreport/item" element={<Inventrycollectionitem/>} />
                     <Route path="/Inventryreport/item" element={<InventoryCollections/>} />
                     <Route path ="Inventrycollectionitemmodal" element={<Inventrycollectionitemmodal/>}   />  
                    */}

                    <Route
                      path="/inventoryreport"
                      element={<Inventryreportdetails />}
                    />
                    <Route
                      path="/inventoryreport/products"
                      element={<Inventryproducts />}
                    />
                    <Route
                      path="/inventoryreport/item"
                      element={<Inventrycollectionitem />}
                    />
                    <Route
                      path="/inventoryreport/item"
                      element={<InventoryCollections />}
                    />
                    <Route
                      path="inventoryreport/item/modal"
                      element={<Inventrycollectionitemmodal />}
                    />

                    {/* Energy */}
                    <Route path="/energy" element={<Energy />} />

                    {/* Settings */}
                    <Route path="/settings" element={<Settings />} />

                    {/* Production */}
                    <Route path="/production" element={<Production />} />
                    <Route
                      path="/production/productionDetails/:orderId"
                      element={<ProductionDetails />}
                    />
                    <Route
                      path="/production/create"
                      element={<ManageProductionLine />}
                    />

                    {/* Catch-All Route */}
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("contentmanager") && (
                  <>
                    <Route path="/dashboard" element={<Products />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route path="/addfaq/:product" element={<ViewProduct />} />
                    <Route
                      path="/products/product/:product"
                      element={<ViewProduct />}
                    />
                    <Route
                      path="/products/items/:product/:collection"
                      element={<Items />}
                    />
                    <Route
                      path="/products/item/:product/:collection"
                      element={<AddItem />}
                    />
                    <Route
                      path="/products/addstyle/:product"
                      element={<ViewProduct />}
                    />
                    <Route
                      path="/products/item/newitem/:product/:collection"
                      element={<AddItem />}
                    />
                    <Route
                      path="/products/addstyle/:productname/:productId"
                      element={<AddStyleAndType />}
                    />
                    <Route
                      path="/products/addtype/:productname/:productId"
                      element={<AddStyleAndType />}
                    />
                    <Route
                      path="/products/addproduct"
                      element={<AddProduct />}
                    />
                    <Route
                      path="/products/product/addcollection/:productName"
                      element={<AddCollection />}
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("ordermanager") && (
                  <>
                    <Route path="/dashboard" element={<Dealers />} />
                    <Route path="/dealers" element={<Dealers />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route path="/dealers/:id" element={<Kyc />} />
                    <Route
                      path="/dealers/transferdealer"
                      element={<TransferDealer />}
                    />
                    <Route
                      path="/dispatch/details/:orderId/:warehouseId"
                      element={
                        width < 1084 ? (
                          <ViewDispatchDetailsMob />
                        ) : (
                          <Newviewdispatchdetails />
                        )
                      }
                    />
                    {/* <Route path="/details/:orderId" element={width < 1084 ? <ViewDispatchDetailsMob /> : <ViewDispatchDetails />} /> */}
                    <Route path="/orders" element={<AllOrders />} />
                    <Route
                      path="/orders/saleinvoice"
                      element={<SaleOrderInovice />}
                    />
                    <Route path="/orders/dealers" element={<OrderDealers />} />
                    <Route
                      path="/orders/estimateinvoice"
                      element={<EstimateInvoice />}
                    />
                    <Route
                      path="/whatsappchats"
                      element={
                        width < 1084 ? (
                          <MainMobileChats />
                        ) : (
                          <MainWhatsappChat />
                        )
                      }
                    />
                    <Route
                      path="/orders/order/saleorder"
                      element={MemoizedSplitScreenLayout}
                    />

                    <Route
                      path="/orders/order/masterorder"
                      element={MemoizedSplitScreenLayout}
                    />

                    <Route
                      path="/orders/order/directcollect"
                      element={MemoizedSplitScreenLayout}
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("inventorymanager") && (
                  <>
                    <Route path="/dashboard" element={<Inventory />} />
                    <Route path="/inventory" element={<Inventory />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route path="/orders" element={<AllOrders />} />
                    <Route path="/orders/order/saleorder" element={<Order />} />
                    <Route path="/orders/order/:route" element={<Order />} />
                    {/* <Route path="/details/:orderId" element={width < 1084 ? <ViewDispatchDetailsMob /> : <ViewDispatchDetails />} /> */}
                    <Route
                      path="/dispatch/details/:orderId/:warehouseId"
                      element={
                        width < 1084 ? (
                          <ViewDispatchDetailsMob />
                        ) : (
                          <Newviewdispatchdetails />
                        )
                      }
                    />
                    <Route
                      path="/transferorders"
                      element={
                        width < 1084 ? (
                          <TransferOrdersMob />
                        ) : (
                          <TransferOrders />
                        )
                      }
                    />
                    <Route
                      path="/orders/transfer"
                      element={<TransferStock />}
                    />
                    <Route
                      path="/orders/saleinvoice"
                      element={<SaleOrderInovice />}
                    />
                    <Route
                      path="/orders/purchaseinvoice/:voucherNo"
                      element={<PurchaseInovice />}
                    />
                    <Route
                      path="/orders/adjustmentinvoice/:voucherNo"
                      element={<AdjustmentInvoice />}
                    />
                    <Route
                      path="/orders/estimateinvoice"
                      element={<EstimateInvoice />}
                    />
                    <Route
                      path="/inventory/:product"
                      element={<InventoryCollections />}
                    />
                    <Route
                      path="/inventory/:product/:collection"
                      element={<CollectionInfo />}
                    />
                    <Route path="/inventory/taxrate" element={<TaxRate />} />
                    {/* Inventryreport report */}
                    <Route
                      path="/inventoryreport"
                      element={<Inventryreportdetails />}
                    />
                    <Route
                      path="/inventoryreport/products"
                      element={<Inventryproducts />}
                    />
                    <Route
                      path="/inventoryreport/item"
                      element={<Inventrycollectionitem />}
                    />
                    <Route
                      path="/inventoryreport/item"
                      element={<InventoryCollections />}
                    />
                    <Route
                      path="inventoryreport/item/modal"
                      element={<Inventrycollectionitemmodal />}
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("dispatchmanager") && (
                  <>
                    <Route
                      path="/dashboard"
                      element={
                        width < 1084 ? (
                          <DispatchDasboardMob />
                        ) : (
                          <DispatchDasboard />
                        )
                      }
                    />
                    <Route path="/dispatch" element={<DispatchDasboard />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route
                      path="/dispatch/dispatchorders/:orderId"
                      element={
                        width < 1084 ? <DispatchOrder /> : <PackingVoucher />
                      }
                    />
                    <Route
                      path="/dispatch/details/:orderId/:warehouseId"
                      element={
                        width < 1084 ? (
                          <ViewDispatchDetailsMob />
                        ) : (
                          <Newviewdispatchdetails />
                        )
                      }
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("paymentmanager") && (
                  <>
                    <Route
                      path="/dashboard"
                      element={width < 1084 ? <ReciptsMob /> : <Recipts />}
                    />
                    <Route
                      path="/recipts"
                      element={width < 1084 ? <ReciptsMob /> : <Recipts />}
                    />
                    <Route path="/profile" element={<AddManager />} />
                    <Route path="/orders/order/:route" element={<Order />} />
                    <Route
                      path="/dispatch/details/:orderId/:warehouseId"
                      element={
                        width < 1084 ? (
                          <ViewDispatchDetailsMob />
                        ) : (
                          <Newviewdispatchdetails />
                        )
                      }
                    />
                    <Route
                      path="/recipts/bulkreception"
                      element={<BulkReception />}
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("packingmanager") && (
                  <>
                    <Route path="/dashboard" element={<PackingOrders />} />
                    <Route path="/packingorder" element={<PackingOrders />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route
                      path="/packingorder/:orderId"
                      element={<PackingOrder />}
                    />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("invoicemanager") && (
                  <>
                    <Route path="/dashboard" element={<Invoices />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/profile" element={<AddManager />} />
                    <Route path="/invoices/invoice" element={<SaleInvoice />} />
                    <Route
                      path="/invoices/uploadedinvoice"
                      element={<UploadInvoice />}
                    />
                    <Route path="/orders/order/saleorder" element={<Order />} />
                    <Route path="/invoices/viewpdf" element={<PdfViewer />} />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("marketing") && (
                  <>
                    <Route path="/dashboard" element={<Marketing />} />
                    <Route path="/marketing" element={<Marketing />} />
                    <Route path="/profile" element={<AddManager />} />
                    {/* <Route path="/marketing/contacts" element={<Contacts />} />
                    <Route path="/marketing/leads" element={<Leads />} />
                    <Route path="/marketing-lead/:id" element={<MarketingLead />} />
                    <Route path="/orders/order/saleorder" element={<Order />} /> */}
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}

                {designations.includes("productionmanager") && (
                  <>
                    <Route path="/dashboard" element={<Production />} />
                    <Route path="/production" element={<Production />} />
                    <Route
                      path="/production/productionDetails/:orderId"
                      element={<ProductionDetails />}
                    />
                    <Route
                      path="/production/create"
                      element={<ManageProductionLine />}
                    />

                    <Route path="/profile" element={<AddManager />} />
                    <Route path="*" element={<NoMatch />} />
                  </>
                )}
              </Route>
            </Routes>
          </div>
        )}
      </Suspense>
    </div>
  );
}

export default App;
